import get from '@invitato/helpers/dist/getLocale';

export default {
  open: get('Buka Undangan', 'Open Invitation'),
  openAnnouncement: get('Buka Pemberitahuan', 'Open Announcement'),
};